import { incYenOf } from '../../../lib/pricing';
const home = {
  // HeroSection
  'home.hero.badge': '一般社団法人全日本執事協会 運営',
  'home.hero.title': '日本で唯一、本格執事育成の',
  'home.hero.titleAccent': '学び舎。',
  'home.hero.subtitle': 'The Japan Butler Academy',
  'home.hero.description': '英国執事文化の伝統と、日本のおもてなし精神が融合した世界水準の執事教育を、お台場の地から。日本の執事学校として、基礎から実務まで体系的に学べます。',
  'home.hero.ctaBrochure': '資料請求はこちら',
  'home.hero.ctaConsultation': '個別相談を予約する',
  'home.hero.ctaPersonal': '個人の受講をご検討の方',
  'home.hero.ctaCorporate': '法人研修をご検討の方',
  'home.hero.imgAlt': '大理石のロビーで背筋を伸ばして佇む日本執事アカデミーの正装の執事',
  'home.hero.imgTitle': '日本執事アカデミー 正装の執事',

  // AudienceSplitSection
  'home.audienceSplit.label': 'FOR INDIVIDUALS & COMPANIES',
  'home.audienceSplit.title': '個人のお客様・法人のお客様',
  'home.audienceSplit.subtitle': 'ご自身の学びとして通学いただく個人のお客様と、貴社に出向いて研修を行う法人のお客様、それぞれに合わせたご案内をご用意しています。',
  'home.audienceSplit.personal.tag': '個人のお客様',
  'home.audienceSplit.personal.tagEn': 'For Individuals',
  'home.audienceSplit.personal.title': '通学型・執事養成コース',
  'home.audienceSplit.personal.desc': '東京・お台場の本校に通い、執事の所作を基礎から体系的に学ぶ通学型の教育プログラムです。土日開催・完全少人数制（定員6名）で、目的に応じた3つのコースからお選びいただけます。',
  'home.audienceSplit.personal.point1': '東京・お台場の本校で対面授業',
  'home.audienceSplit.personal.point2': '土日通学・完全少人数制（定員6名）',
  'home.audienceSplit.personal.point3': 'エッセンシャル／アドバンス／マスターの3コース',
  'home.audienceSplit.personal.cta': '個人のお客様はこちら',
  'home.audienceSplit.personal.imgAlt': '日本執事アカデミーのお台場本校で授業を受ける受講生',
  'home.audienceSplit.corporate.tag': '法人のお客様',
  'home.audienceSplit.corporate.tagEn': 'For Companies',
  'home.audienceSplit.corporate.title': '出張型・法人研修',
  'home.audienceSplit.corporate.desc': 'プロの執事講師が全国どこへでも貴社へ出向く出張型の研修プログラムです。ホテル・金融・高級小売など業種別に設計した8つのプログラムで、現場のおもてなし品質を底上げします。',
  'home.audienceSplit.corporate.point1': '全国対応の出張型（来校型も選択可）',
  'home.audienceSplit.corporate.point2': '業種別に設計した8プログラム',
  'home.audienceSplit.corporate.point3': '半日・1日から選べる実技中心の研修',
  'home.audienceSplit.corporate.cta': '法人のお客様はこちら',
  'home.audienceSplit.corporate.imgAlt': '企業の会議室で接遇研修を受ける法人研修の参加者',

  // AudienceBandHeader
  'home.audienceBand.personal.tagEn': 'For Individuals',
  'home.audienceBand.personal.title': '個人のお客様向け｜お台場校への通学プログラム',
  'home.audienceBand.personal.lead': '東京・お台場の校舎で学ぶ社会人向けの週末通学スタイルです。ここから、コース・カリキュラム・受講環境をご紹介します。',
  'home.audienceBand.personal.cta': '個人のお客様はこちら',
  'home.audienceBand.corporate.tagEn': 'For Companies',
  'home.audienceBand.corporate.title': '法人のお客様向け｜出張型の執事研修プログラム',
  'home.audienceBand.corporate.lead': '講師が貴社へ出向く出張型の研修です。外部会議室での講習や、屋外・現場での実地研修にも対応し、業種別にカスタマイズできます。',
  'home.audienceBand.corporate.cta': '法人のお客様はこちら',

  // AboutSection
  'home.about.label': '一般社団法人全日本執事協会',
  'home.about.title': '日本で唯一の本格的な執事育成機関',
  'home.about.subtitleEn': 'About The Japan Butler Academy',
  'home.about.body1': '日本執事アカデミーは、',
  'home.about.body1Bold': '一般社団法人全日本執事協会',
  'home.about.body1End': 'が運営する、日本で唯一の本格的な執事育成機関です。',
  'home.about.body2': '英国で培われた伝統的な執事の技能と、現代社会が求める高度なホスピタリティ・マネジメントを融合させた独自のカリキュラムを提供しています。',
  'home.about.body3': '新規開校のバトラー養成機関として、伝統と革新の両軸から世界に通用するプロフェッショナルな執事を育成してまいります。',
  'home.about.body4': '完全少人数制（1クラス最大6名）を採用し、講師が受講生一人ひとりの所作に目を配ります。土日の対面授業と予習・復習用のオンデマンド動画を組み合わせたハイブリッド学習により、お仕事を続けながら世界水準の執事教育を学べる環境を整えています。',
  'home.about.body5': '学びの舞台は、高級ホテルのロビーを思わせる東京・お台場の本校。ティーサービスやテーブルセッティング、エスコートの所作を、実際に体を動かしながら体系的に習得します。「売り込む」のではなく「品格で迎え入れる」——執事の本質を、伝統と実践の両面からお伝えします。',
  'home.about.sub2': '伝統と革新を融合した独自カリキュラム',
  'home.about.sub4': '完全少人数制とハイブリッド学習',
  'home.about.sub5': '東京・お台場の本校',
  'home.about.cta': 'アカデミーについて詳しく見る',

  // CoursesSection
  'home.courses.label': 'COURSES',
  'home.courses.title': 'コース紹介',
  'home.courses.schedule': '全コース',
  'home.courses.scheduleDetail1': '土日開催',
  'home.courses.scheduleDetail2': '1日6時間',
  'home.courses.scheduleDetail3': '完全少人数制',
  'home.courses.scheduleDetail3Sub': '（定員6名）',
  'home.courses.scheduleConnector1': '・',
  'home.courses.scheduleConnector2': '（90分×4コマ）・',
  'home.courses.periodLabel': '期間',
  'home.courses.hoursLabel': '総時間',
  'home.courses.daysLabel': '日数',
  'home.courses.priceLabel': '受講料',
  'home.courses.taxNote': '（税込）',
  'home.courses.viewDetail': 'コース詳細を見る',
  'home.courses.scheduleLink': '年間スケジュールを見る',
  // Course image alt/title
  'home.courses.essential.imgAlt': '日本執事アカデミー エッセンシャルコース - ティーサービス実習風景',
  'home.courses.essential.imgTitle': '日本執事アカデミー エッセンシャルコース',
  'home.courses.advanced.imgAlt': '日本執事アカデミー アドバンスコース - ワインサービス実習風景',
  'home.courses.advanced.imgTitle': '日本執事アカデミー アドバンスコース',
  'home.courses.master.imgAlt': '日本執事アカデミー マスターコース - ハウスホールドマネジメント実習風景',
  'home.courses.master.imgTitle': '日本執事アカデミー マスターコース',
  // Essential
  'home.courses.essential.tag': 'ESSENTIAL COURSE',
  'home.courses.essential.title': 'エッセンシャルコース',
  'home.courses.essential.desc': '執事としての基礎的な知識と技能を習得する入門コース。テーブルマナーから基本的なサービススキルまで、執事の土台を固めます。',
  'home.courses.essential.period': '1ヶ月',
  'home.courses.essential.hours': '48時間',
  'home.courses.essential.days': '8日間',
  'home.courses.essential.price': `¥${incYenOf('ac-essential')}`,
  'home.courses.essential.target': '初心者・キャリアチェンジ希望者向け',
  'home.courses.essential.cert': '修了試験合格で『認定アソシエイトバトラー』を授与',
  // Advanced
  'home.courses.advanced.tag': 'ADVANCED COURSE',
  'home.courses.advanced.title': 'アドバンスコース',
  'home.courses.advanced.desc': '実践的なサービステクニックと、より高度なホスピタリティマネジメントを学ぶ中級コース。ワインサービスやイベント運営まで幅広く習得します。',
  'home.courses.advanced.period': '2ヶ月',
  'home.courses.advanced.hours': '72時間',
  'home.courses.advanced.days': '12日間',
  'home.courses.advanced.price': `¥${incYenOf('ac-advanced')}`,
  'home.courses.advanced.target': '基礎知識がある方・スキルアップ希望者向け',
  'home.courses.advanced.cert': '修了試験合格で『認定プロフェッショナルバトラー』を授与',
  // Master
  'home.courses.master.tag': 'MASTER COURSE',
  'home.courses.master.title': 'マスターコース',
  'home.courses.master.desc': '執事としての総合的な専門性とマネジメント能力を極める最上級コース。ハウスホールドマネジメントからコンサルテーションまで、プロフェッショナルとしての全領域を網羅します。',
  'home.courses.master.period': '3ヶ月',
  'home.courses.master.hours': '96時間',
  'home.courses.master.days': '16日間',
  'home.courses.master.price': `¥${incYenOf('ac-master')}`,
  'home.courses.master.target': 'プロ志望者・管理職を目指す方向け',
  'home.courses.master.cert': '修了試験合格で『認定マスターバトラー』を授与',

  // CurriculumSection
  'home.curriculum.label': 'CURRICULUM',
  'home.curriculum.title': 'カリキュラムの特徴',
  'home.curriculum.subtitle': '理論・実践・体系学習の三本柱で、確かな実力を養成します。英国執事の伝統と日本のおもてなしを土台に、執事・バトラーとして現場で通用する実力を育みます。',
  'home.curriculum.theory.title': '理論と実践の融合',
  'home.curriculum.theory.body': '英国執事文化の伝統的な理論体系と、現代社会に即した実践的スキルをバランスよく融合。座学で基礎を固め、実習で即戦力を養います。英国紳士の教養から食事サービス、家政管理まで、執事に必要な領域を幅広くカバーします。',
  'home.curriculum.roleplay.title': 'ロールプレイング実習',
  'home.curriculum.roleplay.body': '多様なシチュエーションを想定したスタジオでのロールプレイング実習。実際の邸宅や高級ホテルを模した環境で、リアルな対応力を磨きます。',
  'home.curriculum.structured.title': '専門教科書による体系学習',
  'home.curriculum.structured.body': '全日本執事協会が監修する専門教科書を使用し、知識を体系的に習得。修了後も参照できる充実の教材で、継続的なスキル向上を支援します。教材は基礎・応用・専門の3系統・全15冊で構成され、目的やレベルに応じて体系的に学べます。',
  'home.curriculum.cta': 'カリキュラムの詳細を見る',

  // BenefitsSection
  'home.benefits.label': 'BENEFITS & CERTIFICATE',
  'home.benefits.title': '受講特典・修了証',
  'home.benefits.subtitle': '各コースには充実の特典が付帯し、修了時には全日本執事協会認定の修了証が授与されます。※特典内容はコースにより異なります。',
  'home.benefits.cta': '料金・特典の詳細を見る',

  // FacilityAccessSection
  'home.facility.label': 'FACILITY & ACCESS',
  'home.facility.title': '施設・アクセス',
  'home.facility.mainCampus': '本校（お台場）',
  'home.facility.postal': '〒135-0064',
  'home.facility.address': '東京都江東区青海2丁目7-4',
  'home.facility.station1': 'ゆりかもめ「',
  'home.facility.station1Name': '東京国際クルーズターミナル駅',
  'home.facility.station1End': '」徒歩約5分',
  'home.facility.station2': 'ゆりかもめ「',
  'home.facility.station2Name': 'テレコムセンター駅',
  'home.facility.station2End': '」徒歩約5分',
  'home.facility.reservationNote': '※ 見学は事前予約制とさせていただいております',
  'home.facility.admissionLabel': 'ADMISSION FLOW',
  'home.facility.admissionTitle': '入学までの流れ',

  'home.facility.imgAlt': '日本執事アカデミー 施設 - お台場の研修施設内観',
  'home.facility.imgTitle': '日本執事アカデミー 施設・アクセス',

  // BenefitsSection
  'home.benefits.imgAlt': '白手袋と教科書を手にした日本執事アカデミーの正装の女性執事',
  'home.benefits.imgTitle': '日本執事アカデミー 受講特典・修了証',

  // CorporateSection
  'home.corporate.img1Alt': '企業研修で受講者に所作を指導する日本人執事講師',
  'home.corporate.img1Title': '法人向け接遇研修 - 立ち居振る舞い指導',
  'home.corporate.img2Alt': 'ホテルスタッフにティーサービスの実技指導を行う日本人執事講師',
  'home.corporate.img2Title': '法人向け接遇研修 - ティーサービス実技',

  // CurriculumSection
  'home.curriculum.img1Alt': '日本執事アカデミー カリキュラム - 理論と実践の融合',
  'home.curriculum.img1Title': '日本執事アカデミー 理論と実践の融合',
  'home.curriculum.img2Alt': '日本執事アカデミー カリキュラム - ロールプレイング実習',
  'home.curriculum.img2Title': '日本執事アカデミー ロールプレイング実習',
  'home.curriculum.img3Alt': '日本執事アカデミー カリキュラム - 専門教科書による体系学習',
  'home.curriculum.img3Title': '日本執事アカデミー 体系学習',

  // BenefitsSection items
  'home.benefits.item0.title': '執事道具セット',
  'home.benefits.item0.desc': 'プロ仕様の執事道具一式を進呈。コース修了後も実務で活用いただけます。',
  'home.benefits.item1.title': '白手袋',
  'home.benefits.item1.desc': '高品質な白手袋(全コース標準支給)。執事の象徴として、初日からサービス実習で着用します。',
  'home.benefits.item2.title': 'オーダーメイドベスト',
  'home.benefits.item2.desc': '受講生お一人おひとりに合わせて仕立てる、アカデミー特製のベスト。',
  'home.benefits.item3.title': '修了証・協会認定資格',
  'home.benefits.item3.desc': '修了実技試験の合格者には、全日本執事協会が認定する資格(認定アソシエイト/プロフェッショナル/マスターバトラー)と認定ピンバッジを授与します。※当協会独自の民間資格です',
  'home.benefits.item4.title': '修了生向けキャリア支援（準備中）',
  'home.benefits.item4.desc': '修了生の方へ、全日本執事協会が把握する執事関連の求人情報を提供する仕組みを予定しています。',

  // AdmissionSteps items
  'home.admission.step0.title': '資料請求',
  'home.admission.step0.titleEn': 'Request Brochure',
  'home.admission.step0.desc': 'まずは資料請求から。コースの詳細やアカデミーの理念をまとめた資料をお送りします。',
  'home.admission.step1.title': '個別相談',
  'home.admission.step1.titleEn': 'Consultation',
  'home.admission.step1.desc': '経験豊富なスタッフが、あなたの目標やご経験に合わせた最適なコース選びをサポートします。',
  'home.admission.step2.title': 'お申込み',
  'home.admission.step2.titleEn': 'Apply',
  'home.admission.step2.desc': 'コースが決まりましたら、所定の申込フォームよりお手続きください。定員になり次第締切となります。',

  // NewsSection items
  'home.news.item3.category': 'お知らせ',
  'home.news.item3.title': '公式サイトをリニューアルいたしました',

  // NewsSection
  'home.news.label': 'NEWS',
  'home.news.title': 'お知らせ',
  'home.news.viewAll': 'お知らせ一覧を見る',

  // HomeFAQSection
  'home.faq.label': 'FAQ',
  'home.faq.title': 'よくあるご質問',
  'home.faq.viewAll': 'すべての質問を見る',
  'home.faq.q1': '未経験でも執事になれますか？',
  'home.faq.a1': 'はい。日本執事アカデミーの全コースは未経験者を歓迎しています。エッセンシャルコースでは基礎の所作から段階的に学べるカリキュラムを採用しており、18歳以上であれば国籍・性別・経験を問わず受講いただけます。',
  'home.faq.q2': '執事の資格は取得できますか？',
  'home.faq.a2': '各コースの修了実技試験に合格すると、一般社団法人全日本執事協会が認定する民間資格（認定アソシエイトバトラー／認定プロフェッショナルバトラー／認定マスターバトラー）と認定ピンバッジを授与します。',
  'home.faq.q3': '受講料の支払い方法を教えてください。',
  'home.faq.a3': '銀行振込による一括払いのみとなります。分割払い・クレジットカードはご利用いただけません。お支払い期限は開校日の14日前です。',
  'home.faq.q4': '仕事をしながら受講できますか？',
  'home.faq.a4': 'はい。全コースを土日開催としており、平日にお勤めの方でも無理なく通学いただけます。エッセンシャルコースは1ヶ月（8日間）、アドバンスコースは2ヶ月（12日間）、マスターコースは3ヶ月（16日間）の日程です。',
  'home.faq.q5': '授業はどのような形式ですか？',
  'home.faq.a5': '土日の対面授業（1日6時間・90分×4コマ）と、予習・復習用のオンデマンド動画講座を組み合わせたハイブリッド形式です。動画で基礎を学び、対面授業では実技と質疑応答に集中していただきます。',
  'home.faq.q6': '少人数制と聞きました。定員は何名ですか？',
  'home.faq.a6': '1クラス最大6名の完全少人数制です。きめ細やかな個別指導のため、最少催行人数は3名としています。ご受講は先着順で承ります。',
  'home.faq.q7': '入学に試験はありますか？',
  'home.faq.a7': '入学選考・試験はございません。18歳以上であれば、国籍・性別・経験を問わず、先着順（定員6名）でお申込みいただけます。',
  'home.faq.q8': 'オンラインだけで受講できますか？',
  'home.faq.a8': '実技を伴う本体授業は、お台場の校舎での対面授業が基本です。予習・復習にはオンデマンド動画をご利用いただけます。なお、無料の個別相談はオンラインでも承っています。',

  // CorporateSection
  'home.corporate.label': 'CORPORATE TRAINING',
  'home.corporate.title': '法人・団体向け研修',
  'home.corporate.subtitle': '日本執事アカデミーは、企業・団体向けの接遇・ビジネスマナー研修も承っています。プロの執事が培った所作ともてなしの型を、貴社の現場で使えるビジネスマナーとして指導します。',
  'home.corporate.formatIntro': '講師が貴社へ出向く出張型の研修です。貴社オフィスに加え、外部会議室での講習や、屋外・現場での実地研修（お出迎え・お見送り、車の乗降サポートなど）にも対応し、ホテル・クリニック・高級住宅・金融・小売など業種ごとにプログラムをカスタマイズいたします。',
  'home.corporate.brochureCta': '法人様向け資料請求はこちら',
  'home.corporate.more': 'ほか、医療・美容クリニック、百貨店外商など幅広い業種に対応しています。',
  'home.corporate.allIndustries': '全業種はこちら',
  'home.corporate.halfDay': '半日',
  'home.corporate.halfDayPrice': incYenOf('ct-single-halfday'),
  'home.corporate.fullDay': '円（税込）〜　1日',
  'home.corporate.fullDayPrice': incYenOf('ct-single-fullday'),
  'home.corporate.fullDayEnd': '円（税込）〜',
  'home.corporate.travel': '全国へ出張いたします（交通費・宿泊費は実費別途）',
  'home.corporate.cta': '法人様の出張型研修はこちら',
  // Industries
  'home.corporate.hotel.name': 'ホテル・旅館',
  'home.corporate.hotel.desc': '開業前研修からバトラーサービスの型まで',
  'home.corporate.residence.name': '高級レジデンス',
  'home.corporate.residence.desc': 'コンシェルジュ・フロントの接遇品質を統一',
  'home.corporate.finance.name': '金融・プライベートバンク',
  'home.corporate.finance.desc': '富裕層営業の信頼を所作から築く',
  'home.corporate.luxury.name': 'ラグジュアリー営業',
  'home.corporate.luxury.desc': '高級車・宝飾・不動産の商談体験を設計',
  'home.corporate.auto.name': '自動車・モビリティ',
  'home.corporate.auto.desc': 'ブランド体験施設・ショールームの接遇品質を向上',
  'home.corporate.chauffeur.name': 'ハイヤー・送迎',
  'home.corporate.chauffeur.desc': '乗降所作・車内気配り・VIP送迎の型を習得',

  // FinalCTASection
  'home.cta.label': 'CONTACT',
  'home.cta.title': 'まずはお気軽に、資料請求から',
  'home.cta.body1': 'コースの詳細や入学に関するご質問など、',
  'home.cta.body2': 'どうぞお気軽にお問い合わせください。',
  'home.cta.brochure': '資料請求はこちら',
  'home.cta.contact': 'お問い合わせはこちら',
  'home.cta.tel': 'TEL: ',
  'home.cta.telNum': '03-6824-4086',
  'home.cta.mail': 'Mail: ',
  'home.cta.mailAddr': 'info@butler-academy.jp',
};

export default home;
